import { ProductListPage } from "@/features/organization/product/pages/ProductList";

export const ProductList = () => {
  return <ProductListPage />;
};
